export default __webpack_public_path__ + "static/media/CatalystSmall.6bdd51d1.jpg";